module.exports = __webpack_public_path__ + "public/images/slider/vebber-circle.08dd77230679437e15bea1c3cbf92e70.png";